import { render, staticRenderFns } from "./status-badge.vue?vue&type=template&id=f8f49370&scoped=true&"
import script from "./status-badge.vue?vue&type=script&lang=ts&"
export * from "./status-badge.vue?vue&type=script&lang=ts&"
import style0 from "./status-badge.vue?vue&type=style&index=0&id=f8f49370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f49370",
  null
  
)

export default component.exports